// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { AssetInfoFragmentDoc } from '../../../assets/AssetPreview.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type UserProjectDocumentsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type UserProjectDocumentsQuery = { __typename?: 'Query', userProjectDocuments: Array<{ __typename?: 'Document', id: string, displayName: string, createdAt: Types.Scalars['DateTime']['input'], isFavorited: boolean, createdBy: { __typename?: 'User', id: string, internalUser?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }> };

export type DocumentsTile_DocumentFragment = { __typename?: 'Document', id: string, displayName: string, createdAt: Types.Scalars['DateTime']['input'], isFavorited: boolean, createdBy: { __typename?: 'User', id: string, internalUser?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } };

export type DocumentsTile_InternalUserFragment = { __typename?: 'InternalUser', id: string, name: string, avatar: string };

export type DocumentsTile_TeamMemberFragment = { __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined, role: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string } };

export type DocumentsTile_RoleFragment = { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string };

export const DocumentsTile_InternalUserFragmentDoc = gql`
    fragment DocumentsTile_InternalUser on InternalUser {
  id
  name
  avatar
}
    `;
export const DocumentsTile_DocumentFragmentDoc = gql`
    fragment DocumentsTile_Document on Document {
  id
  displayName
  createdAt
  isFavorited
  createdBy {
    id
    internalUser {
      ...DocumentsTile_InternalUser
    }
  }
  asset {
    ...AssetInfo
  }
}
    ${DocumentsTile_InternalUserFragmentDoc}
${AssetInfoFragmentDoc}`;
export const DocumentsTile_RoleFragmentDoc = gql`
    fragment DocumentsTile_Role on ProjectRoleDetail {
  code
  name
}
    `;
export const DocumentsTile_TeamMemberFragmentDoc = gql`
    fragment DocumentsTile_TeamMember on ProjectTeamMember {
  user {
    ...DocumentsTile_InternalUser
  }
  role {
    ...DocumentsTile_Role
  }
}
    ${DocumentsTile_InternalUserFragmentDoc}
${DocumentsTile_RoleFragmentDoc}`;
export const UserProjectDocumentsDocument = gql`
    query UserProjectDocuments($projectId: ID!, $limit: Int) {
  userProjectDocuments(project: $projectId, limit: $limit) {
    ...DocumentsTile_Document
  }
}
    ${DocumentsTile_DocumentFragmentDoc}`;

/**
 * __useUserProjectDocumentsQuery__
 *
 * To run a query within a React component, call `useUserProjectDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProjectDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProjectDocumentsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUserProjectDocumentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserProjectDocumentsQuery, UserProjectDocumentsQueryVariables> & ({ variables: UserProjectDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserProjectDocumentsQuery, UserProjectDocumentsQueryVariables>(UserProjectDocumentsDocument, options);
      }
export function useUserProjectDocumentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserProjectDocumentsQuery, UserProjectDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserProjectDocumentsQuery, UserProjectDocumentsQueryVariables>(UserProjectDocumentsDocument, options);
        }
// @ts-ignore
export function useUserProjectDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserProjectDocumentsQuery, UserProjectDocumentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserProjectDocumentsQuery, UserProjectDocumentsQueryVariables>;
export function useUserProjectDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserProjectDocumentsQuery, UserProjectDocumentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserProjectDocumentsQuery | undefined, UserProjectDocumentsQueryVariables>;
export function useUserProjectDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserProjectDocumentsQuery, UserProjectDocumentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserProjectDocumentsQuery, UserProjectDocumentsQueryVariables>(UserProjectDocumentsDocument, options);
        }
export type UserProjectDocumentsQueryHookResult = ReturnType<typeof useUserProjectDocumentsQuery>;
export type UserProjectDocumentsLazyQueryHookResult = ReturnType<typeof useUserProjectDocumentsLazyQuery>;
export type UserProjectDocumentsSuspenseQueryHookResult = ReturnType<typeof useUserProjectDocumentsSuspenseQuery>;
export type UserProjectDocumentsQueryResult = ApolloReactCommon.QueryResult<UserProjectDocumentsQuery, UserProjectDocumentsQueryVariables>;